<template>
    <div id="down-test-page">
        <div class="top_part">
            <div class="button_box">
                <button @click="iosTestDown">iOS - 测试</button>
                <button @click="androidTestDown">Android - 测试</button>
            </div>
            <div class="button_box">
                <button @click="iosFakeDown">iOS Fake下载</button>
                <!-- <button @click="androidDown">Android 下载</button> -->
            </div>
            <div class="button_box">
                <button @click="iosDown">iOS 下载</button>
                <button @click="androidDown">Android 下载</button>
            </div>
            <div class="button_box">
                <button @click="srxIosDown">三人行iOS</button>
                <button @click="srxAndroidDown">三人行Android</button>
            </div>
            <div class="button_box">
                <button @click="srxIosDown('test')">test三人行iOS</button>
                <button @click="srxAndroidDown('test')">test三人行Android</button>
            </div>
            <div class="button_box">
                <button @click="hyIosDown()">汇盈iOS</button>
                <button @click="hyIosDown('test')">汇盈测试iOS</button>
            </div>
        </div>
        <div id="mask" v-show="maskViewShow" @click="maskViewShow = false">
            <span class="mask-tip">请在浏览器中打开</span>
            <img src="@/assets/down/tip_arrow.png"/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TestDownload',
    data() {
        return {
            maskViewShow: false,
            iosUrl: '',
            androidUrl: '',

            status: 'less',
            flag: true,
            angle: 0,
            lessMoreObj: {
                less: 12,
                center: 5,
                more: 3 
            },
            miscUrl: 'https://misc.jgzpro.com',
        }
    },
    mounted() {
        const baseUrl = this.$MyAxios.axiosInstance.defaults.baseURL
        // if(baseUrl === 'https://api.jinguozi.net'){
        //     this.miscUrl = 'http://misc.jgzdata.com'
        // } else {
        //     this.miscUrl = 'https://misc.jinguozi.net'
        // }
    },
    watch: {
    },
    methods: {

        iosTestDown() {
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
                window.location.href = `itms-services://?action=download-manifest&url=${this.miscUrl}/ios/test/mainifest.plist`;
                // window.location.href = `itms-services://?action=download-manifest&url=${this.iosUrl}`;
			}
        },

        iosDown() {
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
                // window.location.href = 'itms-services://?action=download-manifest&url=https://misc.jinguozi.net/ios/mainifest.plist';
                window.location.href = `itms-services://?action=download-manifest&url=${this.miscUrl}/ios/mainifest.plist`;
                // window.location.href = `itms-services://?action=download-manifest&url=${this.iosUrl}`;
			}
        },

        iosFakeDown() {
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
                window.location.href = `itms-services://?action=download-manifest&url=${this.miscUrl}/ios/fake/mainifest.plist`;
                // window.location.href = `itms-services://?action=download-manifest&url=${this.iosUrl}`;
			}
        },

        androidTestDown() {
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
				var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                let url = "http://test.misc.jinguozi.net/testJGZ.apk"
				iframe.src = "javascript: '<script>location.href=\"" + url + "\"<\/script>'";
				document.getElementsByTagName('body')[0].appendChild(iframe);
			}
        },

        androidDown() {
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
				var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                let url = "http://test.misc.jinguozi.net/JGZ.apk"
				iframe.src = "javascript: '<script>location.href=\"" + url + "\"<\/script>'";
				document.getElementsByTagName('body')[0].appendChild(iframe);
			}
        },

        srxIosDown(env) {
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
                if(env === 'test'){
                    window.location.href = `itms-services://?action=download-manifest&url=${this.miscUrl}/srx_down_test/mainifest.plist`;
                } else {
                    window.location.href = `itms-services://?action=download-manifest&url=${this.miscUrl}/srx_down/mainifest.plist`;
                }
			}
        },

        srxAndroidDown() {
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
				var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                let url = "http://test.misc.jinguozi.net/SRX.apk"
				iframe.src = "javascript: '<script>location.href=\"" + url + "\"<\/script>'";
				document.getElementsByTagName('body')[0].appendChild(iframe);
			}
        },

        hyIosDown(type) {
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
                if(type === 'test'){
                    window.location.href = `itms-services://?action=download-manifest&url=${this.miscUrl}/hy_down_test/mainifest.plist`;
                } else {
                    window.location.href = `itms-services://?action=download-manifest&url=${this.miscUrl}/hy_down/mainifest.plist`;
                }
			}
        }

    }
}
</script>

<style lang='less'>
#down-test-page {
	height: 100vh;
	width: 100%;
	background: #ffffff;
	// padding-top: 38px;
	background-size: 100% 100%;
	background-repeat: no-repeat;
    position: relative;
    img {
        pointer-events: none;
    }
    .top_part {
        width: 100%;
        height: 760px;
        background:#FFFFFF;
        padding-top: 60px;
        .button_box {
            height: 90px;
            position: relative;
            margin-bottom: 40px;
        }
        button {
            height: 90px;
            width: 270px;
            outline: none;
            border: none;
            cursor: pointer;
            border-radius: 45px;
            background: #FFA41F;
            box-shadow:0px 6px 16px rgba(255,102,0,0.3);
            position: absolute;
            color: #ffffff;
            font-size: 32px;
            font-weight: bold;
            &:nth-of-type(1) {
                left: 80px;
            }
            &:nth-of-type(2) {
                right: 80px;
            }
            // &:nth-of-type(3) {
            //     top: 554px;
            // }
        }
    }
}
</style>
